const summary = {
  state: () => ({
    summary: null,
    summarySegments: null,
    clickedSummaryCard: null,
    clickedSummaryTimestamp: null,
    isClickedSummaryTimestamp: false,
    isSummaryPlayOn: false,
    isSummaryIconClicked: null,
  }),
  mutations: {
    setSummary(state, payload) {
      state.summary = payload
    },

    setSummarySegments(state, payload) {
      state.summarySegments = payload
    },

    setClickedSummaryCard(state, payload) {
      state.clickedSummaryCard = payload
    },

    setClickedSummaryTimestamp(state, payload) {
      state.clickedSummaryTimestamp = payload
    },

    setIsClickedSummaryTimestamp(state, payload) {
      state.isClickedSummaryTimestamp = payload
    },

    setIsSummaryPlayOn(state, payload) {
      state.isSummaryPlayOn = payload
    },

    setIsSummaryIconClicked(state, payload) {
      state.isSummaryIconClicked = payload
    },
  },
  actions: {
    setSummary({ commit }, payload) {
      commit('setSummary', payload)
    },

    setSummarySegments({ commit }, payload) {
      commit('setSummarySegments', payload)
    },

    setClickedSummaryCard({ commit }, payload) {
      commit('setClickedSummaryCard', payload)
    },

    setClickedSummaryTimestamp({ commit }, payload) {
      commit('setClickedSummaryTimestamp', payload)
    },

    setIsClickedSummaryTimestamp({ commit }, payload) {
      commit('setIsClickedSummaryTimestamp', payload)
    },

    setIsSummaryPlayOn({ commit }, payload) {
      commit('setIsSummaryPlayOn', payload)
    },

    setIsSummaryIconClicked({ commit }, payload) {
      commit('setIsSummaryIconClicked', payload)
    },
  },
  getters: {
    summary(state) {
      return state.summary
    },

    summarySegments(state) {
      return state.summarySegments
    },

    clickedSummaryCard(state) {
      return state.clickedSummaryCard
    },

    clickedSummaryTimestamp(state) {
      return state.clickedSummaryTimestamp
    },

    isClickedSummaryTimestamp(state) {
      return state.isClickedSummaryTimestamp
    },

    isSummaryPlayOn(state) {
      return state.isSummaryPlayOn
    },

    isSummaryIconClicked(state) {
      return state.isSummaryIconClicked
    },
  },
}

export default summary
